import { viajesApi } from "../../../api/viajesApi";
import Swal from "sweetalert2";
import { setQuote, setQuotesList } from "./quotesSlice";
import fileDownload from 'js-file-download'

export const addQuote = (idFile) => {
  return async (dispatch, getState) => {

    try {
      await viajesApi.post("/quotes/quote", { idFile });
      dispatch(getQuotesListByIdFile(idFile))
    } catch (error) {
      
    }

  }
}

export const getQuotesListByIdFile = (idFile) => {
  return async (dispatch, getState) => {
    try {
      const resp = await viajesApi.get("/quotes/byIdFile", {
        params: {
          idFile
        }
      });
      dispatch(setQuotesList(resp.data.results));
    } catch (error) {
      dispatch(setQuotesList([]));
    }
  }
}


export const editQuoteDescription = (id, description, success) => {
  return async (dispatch, getState) => {

    try {
      const resp = await viajesApi.put("/quotes/description", { id, description });
      dispatch(getQuoteById(id));
      success();
      Swal.fire("Cotizaciones", resp.data.msg, "success");
    } catch (error) {
      Swal.fire("Cotizaciones", error.response.data.msg, "error");
    }
  }
}

export const addQuoteToSale = (id, accepted) => {
  return async (dispatch, getState) => {

    try {
      const resp = await viajesApi.put("/quotes/quoteToSale", { id, accepted });
      dispatch(getQuoteById(id));
      Swal.fire("Cotizaciones", resp.data.msg, "success");
    } catch (error) {
      Swal.fire("Cotizaciones", error.response.data.msg, "error");
    }

  }
}

export const addAirQuote = (idQuote, departureDate, returnDate, idAirline, idWholesaler, outboundItinerary,
  returnItinerary, rate, fee, idCurrency, notes, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.post("/quotes/airQuote", {
        idQuote, departureDate, returnDate, idAirline, idWholesaler, outboundItinerary,
        returnItinerary, rate, fee, idCurrency, notes
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const getQuoteById = (idQuote) => {
  return async (dispatch, getState) => {
    try {
      const resp = await viajesApi.get("/quotes/byId", {
        params: {
          idQuote
        }
      });
      dispatch(setQuote(resp.data.results));
    } catch (error) {
      dispatch(setQuote({}));
    }
  }
}

export const editAirQuote = (id, departureDate, returnDate,idAirline, idWholesaler, outboundItinerary,
  returnItinerary, rate, fee, idCurrency, notes, idQuote, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.put("/quotes/airQuote", {
        id, departureDate, returnDate, idAirline, idWholesaler, outboundItinerary,
        returnItinerary, rate, fee, idCurrency, notes
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const deleteAirQuote = (id, idQuote, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.delete("/quotes/airQuote", { params: { id } });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}


export const addLodgingQuote = (idQuote, checkInDate, checkOutDate, idHotel, idWholesaler,
  idCurrency, notes, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.post("/quotes/lodgingQuote", {
        idQuote, checkInDate, checkOutDate, idHotel, idWholesaler,
        idCurrency, notes,
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const editLodgingQuote = (id, checkInDate, checkOutDate, idHotel, idWholesaler,
  idCurrency, notes, idQuote, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.put("/quotes/lodgingQuote", {
        id, checkInDate, checkOutDate, idHotel, idWholesaler, idCurrency, notes
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const deleteLodingQuote = (id, idQuote, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.delete("/quotes/lodgingQuote", { params: { id } });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const addRoomLodging = (idLodging, room, adults, juniors, minors, infants, rate, netPrice, idQuote, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.post("/quotes/roomLodging", {
        idLodging, room, adults, juniors, minors, infants, rate, netPrice
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const editRoomLodging = (id, room, adults, juniors, minors, infants, rate, netPrice, idQuote, success) => {
  return async (dispatch, getState) => {

    try {
      await viajesApi.put("/quotes/roomLodging", {
        id, room, adults, juniors, minors, infants, rate, netPrice
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const deleteRoomLodging = (id, idQuote, success) => {
  return async (dispatch, getState) => {

    try {
      await viajesApi.delete("/quotes/roomLodging", { params: { id } });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const addCruiseQuote = (idQuote, departureDate, returnDate, company, idWholesaler, ship, port,
  idCurrency, notes, route, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.post("/quotes/cruiseQuote", {
        idQuote, departureDate, returnDate, company, idWholesaler, ship, port,
        idCurrency, notes, route,
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const editCruiseQuote = (id, departureDate, returnDate, company, idWholesaler, ship, port, route,
  notes, idCurrency, idQuote, success) => {
  return async (dispatch, getState) => {

    try {
      await viajesApi.put("/quotes/cruiseQuote", {
        id, departureDate, returnDate, company, idWholesaler, ship, port, route, notes, idCurrency
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const deleteCruiseQuote = (id, idQuote, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.delete("/quotes/cruiseQuote", { params: { id } });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const addCabinCruise = (idCruise, cabin, rate, netPrice, tax, tip, idQuote, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.post("/quotes/cabinCruise", {
        idCruise, cabin, rate, netPrice, tax, tip
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const editCabinCruise = (id, cabin, rate, netPrice, tax, tip, idQuote, success) => {
  return async (dispatch, getState) => {

    try {
      await viajesApi.put("/quotes/cabinCruise", {
        id, cabin, rate, netPrice, tax, tip
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const deleteCabinCruise = (id, idQuote, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.delete("/quotes/cabinCruise", { params: { id } });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const addServiceQuote = (idQuote, startDate, endDate, service, idWholesaler, details, rate,
  netPrice, idCurrency, notes, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.post("/quotes/serviceQuote", {
        idQuote, startDate, endDate, service, idWholesaler, details, rate, netPrice,
        idCurrency, notes,
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const editServiceQuote = (id, startDate, endDate, service, idWholesaler, details, rate,
  netPrice, idCurrency, notes, idQuote, success) => {
  return async (dispatch, getState) => {

    try {
      await viajesApi.put("/quotes/serviceQuote", {
        id, startDate, endDate, service, idWholesaler, details, rate, netPrice, idCurrency, notes,
      });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}

export const deleteServiceQuote = (id, idQuote, success) => {

  return async (dispatch, getState) => {

    try {
      await viajesApi.delete("/quotes/serviceQuote", { params: { id } });
      success();
      dispatch(getQuoteById(idQuote))
    } catch (error) {
    }
  }
}


export const addIndividualQuote = (idIndividualFile) => {
  return async (dispatch, getState) => {

    try {
      await viajesApi.post("/quotes/individualQuote", { idIndividualFile });
      dispatch(getQuotesListByIdIndividualFile(idIndividualFile))
    } catch (error) {
    }

  }
}

export const getQuotesListByIdIndividualFile = (idIndividualFile) => {
  return async (dispatch, getState) => {
    try {
      const resp = await viajesApi.get("/quotes/byIdIndividualFile", {
        params: {
          idIndividualFile
        }
      });
      dispatch(setQuotesList(resp.data.results));
    } catch (error) {
      dispatch(setQuotesList([]));
    }
  }
}

export const quoteSummary = (id) => {
  return async (dispatch, getState) => {
    try {
      const resp = await viajesApi.get("/quotes/quoteSummary", {
        params: {
          id
        },
        responseType: 'blob',
      });
      fileDownload(resp.data, `Cotizacion ${id}.pdf`);
      Swal.fire("Archivos", "Comprobante descargado correctamente", "success");
    } catch (error) {
      Swal.fire("Archivos", error.response.data.msg, "error");
    }
  }
}